import { Helmet } from "react-helmet-async";
import { OpenGraphMetadata } from "@/lib/openGraph";

const OpenGraphTags = (meta: OpenGraphMetadata) => {
  return (
    <Helmet>
      <title>{meta.documentTitle ?? meta.title}</title>
      <meta
        name="description"
        content={meta.searchDescription ?? meta.description}
      />
      {meta.robots ? <meta name="robots" content={meta.robots} /> : null}
      <link rel="canonical" href={meta.url} />
      <meta property="og:site_name" content={meta.siteName} />
      <meta property="og:locale" content={meta.locale} />
      <meta property="og:type" content={meta.type} />
      <meta property="og:url" content={meta.url} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      {meta.imageUrl ? (
        <>
          <meta property="og:image" content={meta.imageUrl} />
          <meta property="og:image:secure_url" content={meta.imageUrl} />
          <meta property="og:image:alt" content={meta.imageAlt} />
          {meta.imageKind === "cover" ? (
            <>
              <meta property="og:image:width" content="1200" />
              <meta property="og:image:height" content="630" />
            </>
          ) : null}
          {meta.imageType ? (
            <meta property="og:image:type" content={meta.imageType} />
          ) : null}
        </>
      ) : null}
      <meta name="twitter:card" content={meta.twitterCard} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      {meta.imageUrl ? (
        <>
          <meta name="twitter:image" content={meta.imageUrl} />
          <meta name="twitter:image:alt" content={meta.imageAlt} />
        </>
      ) : null}
    </Helmet>
  );
};

export default OpenGraphTags;
